import FieldTextarea from '@/components/common/Field/FieldTextarea/Field';
import Textarea from '@/components/common/Input/Textarea/Textarea';
import { privacyText, termsText } from '@/constants/terms';

import * as S from './style';
import { useSignUpStore } from '../SignUpContext/SignUpContext';

interface TermsProps {
	serviceAgree: boolean;
	privacyAgree: boolean;
	handleServiceAgree: (bool: boolean) => void;
	handlePrivacyAgree: (bool: boolean) => void;
}

const Terms = ({ serviceAgree, privacyAgree, handlePrivacyAgree, handleServiceAgree }: TermsProps) => {
	const { setStep, setCurrentStep } = useSignUpStore();

	const handleNext = () => {
		if (serviceAgree && privacyAgree) {
			setStep('기본정보 입력');
			setCurrentStep('기본정보 입력');
		} else {
			alert('모든 약관에 동의해 주세요.');
		}
	};

	return (
		<S.FieldBox>
			<FieldTextarea title="서비스 이용 약관">
				<Textarea value={termsText} />
				<S.FieldCheckBox>
					<input type="checkbox" id="agree" name="agree" checked={serviceAgree} onChange={() => handleServiceAgree(!serviceAgree)} />
					서비스 이용 약관에 동의합니다.
				</S.FieldCheckBox>
			</FieldTextarea>
			<FieldTextarea title="개인정보 수집 및 정책">
				<Textarea value={privacyText} />
				<S.FieldCheckBox>
					<input type="checkbox" id="agree" name="agree" value="agree" checked={privacyAgree} onChange={() => handlePrivacyAgree(!privacyAgree)} />
					개인정보 수집 및 정책에 동의합니다.
				</S.FieldCheckBox>
			</FieldTextarea>
			<S.NextButton type="button" disabled={!serviceAgree || !privacyAgree} onClick={handleNext}>
				다음
			</S.NextButton>
		</S.FieldBox>
	);
};

export default Terms;
